import { useNavigate } from "react-router-dom"

import { Card, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { TOOLS } from "@/constants/tools"
import { getFirstName } from "@/lib/users"

import { useUserSession } from "@session/UserSession"

export function DashboardPanel() {
    const { authToken } = useUserSession()
    const navigate = useNavigate()

    return (
        <div className="flex flex-col items-center justify-start w-full h-full max-w-[90%] mx-auto gap-12 pt-12 pb-12">
            <div className="flex flex-row items-center justify-center w-full">
                <p className="text-center text-2xl font-medium tracking-tight">
                    Hey <span className="text-[#575876] hover:cursor-pointer hover:underline">{getFirstName(authToken?.name)}</span>, good to have you back
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 w-full">
                {
                    TOOLS.map((tool) => {
                        const Icon = tool.icon
                        return (
                            <Card
                                key={tool.path}
                                className="hover:shadow-lg transition-shadow cursor-pointer hover:border-primary/50"
                                onClick={() => navigate(tool.path)}
                            >
                                <CardHeader>
                                    <div className="flex items-center gap-3 mb-2">
                                        <tool.icon className="size-6 text-primary" />
                                        <CardTitle className="text-xl">{tool.title}</CardTitle>
                                    </div>
                                    <CardDescription className="text-base">{tool.description}</CardDescription>
                                </CardHeader>
                            </Card>
                        )
                    })
                }
            </div>
        </div>
    )
}
